module.exports = __webpack_public_path__ + "static/media/learn.8eb98f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscription/learn.jpg
// module id = 2924
// module chunks = 0